<template>
	<div class="container">
		<div class="content">
			<div class="dynamic-wrap">
				<dynamicItem :list="dataList"/>
			</div>
			<div class="pagination-wrap">
				<el-pagination
				  background
				  layout="prev, pager, next"
				  :page-size= this.pageSize
				  :total=this.total
				  @current-change="handleCurrentChange"
				  hide-on-single-page
				  >
				</el-pagination>
			</div>
		</div>
		
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	import dynamicItem from '@/components/dynamicItem'
	export default {
		name: 'Dynamic',
		components: {
			dynamicItem
		},
		data(){
			return {
				dataList: [],
				pageNum: 1,
				pageSize: 10,
				total: 0
			}
		},
		created(){
			this.getDataList()
		},
		methods: {
			handleCurrentChange(e){
				this.dataList = []
				this.pageNum = e
				this.getDataList()
			},
			//获取动态数据 
			async getDataList(){
				let param = {
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('v1/feed/list', qs.stringify(param))
				if(res.data.code==200){
					let list = res.data.page.items
					list.forEach(item=>{
						item.previewList = []
						if(item.attachList.length>0) {
							item.attachList.forEach(subitem=>{
								item.previewList.push(subitem.fileUrl)
							})
						}
					})
					this.dataList = list
					
					this.total =  res.data.page.count
				} else {
					this.$message.error(res.data.msg)
				}
			},
		}
	}
</script>

<style scoped lang="less">
	.content{
		background: #fff;
		padding: 20px;
		box-sizing: border-box;
		.pagination-wrap{
			margin-top: 40px;
		}
	}
</style>
